/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Container } from '@adobe-commerce/elsie/lib';
import { UpdatePasswordForm } from '@/auth/components';
import { UpdatePasswordProps } from '@/auth/types';

export const UpdatePassword: Container<UpdatePasswordProps> = ({
  slots,
  formSize,
  signInOnSuccess,
  routeRedirectOnPasswordUpdate,
  routeRedirectOnSignIn,
  routeSignInPage,
  routeWrongUrlRedirect,
  onErrorCallback,
  onSuccessCallback,
}) => {
  return (
    <div className="auth-update-password">
      <UpdatePasswordForm
        formSize={formSize}
        signInOnSuccess={signInOnSuccess}
        routeSignInPage={routeSignInPage}
        routeRedirectOnSignIn={routeRedirectOnSignIn}
        routeWrongUrlRedirect={routeWrongUrlRedirect}
        onErrorCallback={onErrorCallback}
        onSuccessCallback={onSuccessCallback}
        slots={slots}
        routeRedirectOnPasswordUpdate={routeRedirectOnPasswordUpdate}
      />
    </div>
  );
};
